export default __webpack_public_path__ + "static/media/65t.cc6f65fa.jpg";